import React from 'react'

const DotsIcon: React.FC = () => (
	<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.6665 8.5C13.7665 8.5 14.6665 7.6 14.6665 6.5C14.6665 5.4 13.7665 4.5 12.6665 4.5C11.5665 4.5 10.6665 5.4 10.6665 6.5C10.6665 7.6 11.5665 8.5 12.6665 8.5ZM12.6665 10.5C11.5665 10.5 10.6665 11.4 10.6665 12.5C10.6665 13.6 11.5665 14.5 12.6665 14.5C13.7665 14.5 14.6665 13.6 14.6665 12.5C14.6665 11.4 13.7665 10.5 12.6665 10.5ZM12.6665 16.5C11.5665 16.5 10.6665 17.4 10.6665 18.5C10.6665 19.6 11.5665 20.5 12.6665 20.5C13.7665 20.5 14.6665 19.6 14.6665 18.5C14.6665 17.4 13.7665 16.5 12.6665 16.5Z"
			fill="#4C4E64"
			fill-opacity="0.38"
		/>
	</svg>
)

export default DotsIcon
